(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'react', 'react-router-dom', './withAuthProvider', './RedirectToLogin'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('react-router-dom'), require('./withAuthProvider'), require('./RedirectToLogin'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.reactRouterDom, global.withAuthProvider, global.RedirectToLogin);
    global.PrivateRoute = mod.exports;
  }
})(this, function (exports, _extends2, _objectWithoutProperties2, _react, _reactRouterDom, _withAuthProvider, _RedirectToLogin) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PrivateRouteGatsby = undefined;

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _react2 = _interopRequireDefault(_react);

  var _withAuthProvider2 = _interopRequireDefault(_withAuthProvider);

  var _RedirectToLogin2 = _interopRequireDefault(_RedirectToLogin);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var spinnerStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display: 'block',
    width: '100px',
    height: '100px',
    margin: '-50px 0 0 -50px'
  };

  var Spinner = function Spinner() {
    return _react2.default.createElement(
      'svg',
      { style: spinnerStyles, xmlns: 'http://www.w3.org/2000/svg', preserveAspectRatio: 'xMidYMid', viewBox: '0 0 100 100' },
      _react2.default.createElement('path', { fill: 'none', d: 'M0 0h100v100H0z' }),
      _react2.default.createElement(
        'defs',
        null,
        _react2.default.createElement(
          'filter',
          { id: 'a', width: '300%', height: '300%', x: '-100%', y: '-100%' },
          _react2.default.createElement('feOffset', { 'in': 'SourceGraphic', result: 'offOut' }),
          _react2.default.createElement('feGaussianBlur', { 'in': 'offOut', result: 'blurOut' }),
          _react2.default.createElement('feBlend', { 'in': 'SourceGraphic', in2: 'blurOut' })
        )
      ),
      _react2.default.createElement(
        'path',
        { fill: '#337ab7', d: 'M10 50s0 .5.1 1.4c0 .5.1 1 .2 1.7 0 .3.1.7.1 1.1.1.4.1.8.2 1.2.2.8.3 1.8.5 2.8.3 1 .6 2.1.9 3.2.3 1.1.9 2.3 1.4 3.5.5 1.2 1.2 2.4 1.8 3.7.3.6.8 1.2 1.2 1.9.4.6.8 1.3 1.3 1.9 1 1.2 1.9 2.6 3.1 3.7 2.2 2.5 5 4.7 7.9 6.7 3 2 6.5 3.4 10.1 4.6 3.6 1.1 7.5 1.5 11.2 1.6 4-.1 7.7-.6 11.3-1.6 3.6-1.2 7-2.6 10-4.6 3-2 5.8-4.2 7.9-6.7 1.2-1.2 2.1-2.5 3.1-3.7.5-.6.9-1.3 1.3-1.9.4-.6.8-1.3 1.2-1.9.6-1.3 1.3-2.5 1.8-3.7.5-1.2 1-2.4 1.4-3.5.3-1.1.6-2.2.9-3.2.2-1 .4-1.9.5-2.8.1-.4.1-.8.2-1.2 0-.4.1-.7.1-1.1.1-.7.1-1.2.2-1.7.1-.9.1-1.4.1-1.4V54.2c0 .4-.1.8-.1 1.2-.1.9-.2 1.8-.4 2.8-.2 1-.5 2.1-.7 3.3-.3 1.2-.8 2.4-1.2 3.7-.2.7-.5 1.3-.8 1.9-.3.7-.6 1.3-.9 2-.3.7-.7 1.3-1.1 2-.4.7-.7 1.4-1.2 2-1 1.3-1.9 2.7-3.1 4-2.2 2.7-5 5-8.1 7.1L70 85.7c-.8.5-1.7.9-2.6 1.3l-1.4.7-1.4.5c-.9.3-1.8.7-2.8 1C58 90.3 53.9 90.9 50 91l-3-.2c-1 0-2-.2-3-.3l-1.5-.2-.7-.1-.7-.2c-1-.3-1.9-.5-2.9-.7-.9-.3-1.9-.7-2.8-1l-1.4-.6-1.3-.6c-.9-.4-1.8-.8-2.6-1.3l-2.4-1.5c-3.1-2.1-5.9-4.5-8.1-7.1-1.2-1.2-2.1-2.7-3.1-4-.5-.6-.8-1.4-1.2-2-.4-.7-.8-1.3-1.1-2-.3-.7-.6-1.3-.9-2-.3-.7-.6-1.3-.8-1.9-.4-1.3-.9-2.5-1.2-3.7-.3-1.2-.5-2.3-.7-3.3-.2-1-.3-2-.4-2.8-.1-.4-.1-.8-.1-1.2v-1.1-1.7c-.1-1-.1-1.5-.1-1.5z', filter: 'url(#a)' },
        _react2.default.createElement('animateTransform', { attributeName: 'transform', dur: '1s', from: '0 50 50', repeatCount: 'indefinite', to: '360 50 50', type: 'rotate' })
      )
    );
  };

  var checkLogin = function checkLogin(_ref) {
    var isLoggedIn = _ref.isLoggedIn,
        requiredRole = _ref.requiredRole,
        role = _ref.role;
    return isLoggedIn && (!requiredRole || requiredRole === role);
  };

  var PrivateRoute = (0, _withAuthProvider2.default)(function (_ref2) {
    var authReady = _ref2.authReady,
        me = _ref2.me,
        returnTo = _ref2.returnTo,
        _ref2$loader = _ref2.loader,
        Loader = _ref2$loader === undefined ? Spinner : _ref2$loader,
        PrivateComponent = _ref2.component,
        rest = (0, _objectWithoutProperties3.default)(_ref2, ['authReady', 'me', 'returnTo', 'loader', 'component']);

    if (!authReady) return _react2.default.createElement(Loader, null);

    return _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
      render: function render(renderProps) {
        return checkLogin(rest) ? _react2.default.createElement(PrivateComponent, renderProps) : _react2.default.createElement(_RedirectToLogin2.default, { returnTo: returnTo });
      }
    }));
  });

  var PrivateRouteGatsby = (0, _withAuthProvider2.default)(function (_ref3) {
    var authReady = _ref3.authReady,
        returnTo = _ref3.returnTo,
        _ref3$loader = _ref3.loader,
        Loader = _ref3$loader === undefined ? Spinner : _ref3$loader,
        PrivateComponent = _ref3.component,
        rest = (0, _objectWithoutProperties3.default)(_ref3, ['authReady', 'returnTo', 'loader', 'component']);

    if (!authReady) return _react2.default.createElement(Loader, null);
    return checkLogin(rest) ? PrivateComponent : _react2.default.createElement(_RedirectToLogin2.default, { returnTo: returnTo });
  });

  exports.default = PrivateRoute;
  exports.PrivateRouteGatsby = PrivateRouteGatsby;
});